let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("eZlSX"), load("7zPyN")]).then(() => parcelRequire('3rsEl'));